import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { ContractsResponse } from "@/types";

async function fetchContracts(
  id: string,
  contractableType: string,
  page?: string | null
): Promise<ContractsResponse> {
  const contract = await httpRequest.get<ContractsResponse>(
    `/contracts/contractable/${id}?contractable_type=${contractableType}&page=${page || 1}`
  );
  return contract.data;
}

export function useFetchContractsQuery({
  id,
  contractableType,
  page,
}: {
  id: string;
  contractableType: string;
  page?: string | null;
}) {
  const contractsQuery = useQuery({
    queryKey: ["contracts", id, contractableType, page],
    queryFn: () => fetchContracts(id, contractableType, page),
    keepPreviousData: true,
  });

  return {
    ...contractsQuery,
    data: contractsQuery?.data,
  };
}
